import { render, staticRenderFns } from "./regulamin.vue?vue&type=template&id=5ede35bf&"
import script from "./regulamin.vue?vue&type=script&lang=js&"
export * from "./regulamin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LegalDocument: require('/var/www/jaty-frontend/components/LegalDocument.vue').default})
